/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Scoring_DimensionsInputs */

const en_deep_match_scoring_dimensions = /** @type {(inputs: Deep_Match_Scoring_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoring Dimensions`)
};

const de_deep_match_scoring_dimensions = /** @type {(inputs: Deep_Match_Scoring_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoring Dimensions`)
};

const fr_deep_match_scoring_dimensions = /** @type {(inputs: Deep_Match_Scoring_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoring Dimensions`)
};

const es_deep_match_scoring_dimensions = /** @type {(inputs: Deep_Match_Scoring_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoring Dimensions`)
};

const it_deep_match_scoring_dimensions = /** @type {(inputs: Deep_Match_Scoring_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoring Dimensions`)
};

const nl_deep_match_scoring_dimensions = /** @type {(inputs: Deep_Match_Scoring_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoring Dimensions`)
};

const pl_deep_match_scoring_dimensions = /** @type {(inputs: Deep_Match_Scoring_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoring Dimensions`)
};

const fi_deep_match_scoring_dimensions = /** @type {(inputs: Deep_Match_Scoring_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoring Dimensions`)
};

const da_deep_match_scoring_dimensions = /** @type {(inputs: Deep_Match_Scoring_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoring Dimensions`)
};

const sv_deep_match_scoring_dimensions = /** @type {(inputs: Deep_Match_Scoring_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoring Dimensions`)
};

/**
* | output |
* | --- |
* | "Scoring Dimensions" |
*
* @param {Deep_Match_Scoring_DimensionsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_scoring_dimensions = /** @type {((inputs?: Deep_Match_Scoring_DimensionsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Scoring_DimensionsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_scoring_dimensions(inputs)
	if (locale === "fr") return fr_deep_match_scoring_dimensions(inputs)
	if (locale === "es") return es_deep_match_scoring_dimensions(inputs)
	if (locale === "it") return it_deep_match_scoring_dimensions(inputs)
	if (locale === "nl") return nl_deep_match_scoring_dimensions(inputs)
	if (locale === "pl") return pl_deep_match_scoring_dimensions(inputs)
	if (locale === "fi") return fi_deep_match_scoring_dimensions(inputs)
	if (locale === "da") return da_deep_match_scoring_dimensions(inputs)
	if (locale === "sv") return sv_deep_match_scoring_dimensions(inputs)
	return en_deep_match_scoring_dimensions(inputs)
});